import { render, staticRenderFns } from "./ChildrenGrandchildrenYN.vue?vue&type=template&id=5a289220"
import script from "./ChildrenGrandchildrenYN.vue?vue&type=script&lang=js"
export * from "./ChildrenGrandchildrenYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports